import axios from 'axios';
import Cookies from 'universal-cookie';

// ─── Action Types ───────────────────────────────────────────────────────────
const FETCH_REPORT_START = 'informesAI/FETCH_REPORT_START';
const FETCH_REPORT_SUCCESS = 'informesAI/FETCH_REPORT_SUCCESS';
const FETCH_REPORT_ERROR = 'informesAI/FETCH_REPORT_ERROR';

const FETCH_CONVERSATIONS_START = 'informesAI/FETCH_CONVERSATIONS_START';
const FETCH_CONVERSATIONS_SUCCESS = 'informesAI/FETCH_CONVERSATIONS_SUCCESS';
const FETCH_CONVERSATIONS_ERROR = 'informesAI/FETCH_CONVERSATIONS_ERROR';
const CLEAR_AGENT_CONVERSATIONS = 'informesAI/CLEAR_AGENT_CONVERSATIONS';

const ANALYZE_START = 'informesAI/ANALYZE_START';
const ANALYZE_SUCCESS = 'informesAI/ANALYZE_SUCCESS';
const ANALYZE_ERROR = 'informesAI/ANALYZE_ERROR';
const CLEAR_ANALYSIS = 'informesAI/CLEAR_ANALYSIS';

// ─── Initial State ───────────────────────────────────────────────────────────
const initialState = {
    report: null,
    loading: false,
    error: null,
    agentConversations: [],
    loadingConversations: false,
    conversationsError: null,
    analysis: null,
    analyzing: false,
    analysisError: null,
};

// ─── Reducer ─────────────────────────────────────────────────────────────────
export default function informesAIReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_REPORT_START:
            return { ...state, loading: true, error: null };
        case FETCH_REPORT_SUCCESS:
            return { ...state, loading: false, report: action.payload };
        case FETCH_REPORT_ERROR:
            return { ...state, loading: false, error: action.payload };

        case FETCH_CONVERSATIONS_START:
            return { ...state, loadingConversations: true, conversationsError: null };
        case FETCH_CONVERSATIONS_SUCCESS:
            return { ...state, loadingConversations: false, agentConversations: action.payload };
        case FETCH_CONVERSATIONS_ERROR:
            return { ...state, loadingConversations: false, conversationsError: action.payload };
        case CLEAR_AGENT_CONVERSATIONS:
            return { ...state, agentConversations: [] };

        case ANALYZE_START:
            return { ...state, analyzing: true, analysisError: null };
        case ANALYZE_SUCCESS:
            return { ...state, analyzing: false, analysis: action.payload };
        case ANALYZE_ERROR:
            return { ...state, analyzing: false, analysisError: action.payload };
        case CLEAR_ANALYSIS:
            return { ...state, analysis: null, analysisError: null };

        default:
            return state;
    }
}

// ─── Thunks ──────────────────────────────────────────────────────────────────
const getAuthHeader = () => {
    const cookies = new Cookies();
    return { Authorization: `Bearer ${cookies.get('token')}` };
};

export const fetchAgentStatsFromAPI = (from, to, businessLineId) => async (dispatch) => {
    dispatch({ type: FETCH_REPORT_START });
    try {
        const params = { from: from.toISOString(), to: to.toISOString() };
        if (businessLineId) params.businessLineId = businessLineId;
        const { data } = await axios.get(
            `${window.API_BASE_URL}/reports/agent-stats`,
            { params, headers: getAuthHeader() }
        );
        dispatch({ type: FETCH_REPORT_SUCCESS, payload: data });
    } catch (err) {
        dispatch({ type: FETCH_REPORT_ERROR, payload: err.message });
    }
};

export const fetchAgentConversationsFromAPI = (agentUserId, from, to, businessLineId) => async (dispatch) => {
    dispatch({ type: FETCH_CONVERSATIONS_START });
    try {
        const params = { from: from.toISOString(), to: to.toISOString() };
        if (businessLineId) params.businessLineId = businessLineId;
        const { data } = await axios.get(
            `${window.API_BASE_URL}/reports/agent-conversations/${agentUserId}`,
            { params, headers: getAuthHeader() }
        );
        dispatch({ type: FETCH_CONVERSATIONS_SUCCESS, payload: data });
    } catch (err) {
        dispatch({ type: FETCH_CONVERSATIONS_ERROR, payload: err.message });
    }
};

export const clearAgentConversations = () => ({ type: CLEAR_AGENT_CONVERSATIONS });

export const analyzeAgentFromAPI = (agentUserId, from, to, businessLineId) => async (dispatch) => {
    dispatch({ type: ANALYZE_START });
    try {
        const params = { from: from.toISOString(), to: to.toISOString() };
        if (businessLineId) params.businessLineId = businessLineId;
        const { data } = await axios.post(
            `${window.API_BASE_URL}/reports/agent-analysis/${agentUserId}`,
            null,
            { params, headers: getAuthHeader() }
        );
        dispatch({ type: ANALYZE_SUCCESS, payload: data });
    } catch (err) {
        dispatch({ type: ANALYZE_ERROR, payload: err?.response?.data ?? err.message });
    }
};

export const clearAgentAnalysis = () => ({ type: CLEAR_ANALYSIS });
